/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Data_FreshnessInputs */

const fr_help_data_freshness = /** @type {(inputs: Help_Data_FreshnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fraîcheur des données`)
};

const en_help_data_freshness = /** @type {(inputs: Help_Data_FreshnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data freshness`)
};

/**
* | output |
* | --- |
* | "Data freshness" |
*
* @param {Help_Data_FreshnessInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const help_data_freshness = /** @type {((inputs?: Help_Data_FreshnessInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Data_FreshnessInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_help_data_freshness(inputs)
	return en_help_data_freshness(inputs)
});